import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { CloseIcon, ChevronLeftIcon } from 'ui-component/custom-icons/icons';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import toast from 'react-hot-toast';

import PdfViewer from 'ui-component/PdfViewer';
import { motion, AnimatePresence } from 'framer-motion';
import { Skeleton, Avatar, Tooltip } from '@mui/material';
import useIsMobile from 'utils/isMobileUtils';
import { IoSearchOutline } from 'react-icons/io5';

const EventFormModal = ({ show, id, action, handleClose, reloadList }) => {
    const [showPreviewDocument, setShowPreviewDocument] = useState(false);
    const [showAttendance, setShowAttendance] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isMemberLoading, setIsMemberLoading] = useState(true);
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [searchField, setSearchField] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [membersList, setMembersList] = useState([]);
    const [originalList, setOriginalList] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState('');
    const [data, setData] = useState({
        id: '',
        name: '',
        location: '',
        date: '',
        participants: []
    });
    useEffect(() => { 
        setIsVisible(show);
    }, [show]);


    useEffect(() => {
        if(id) {
            initializeData()
        }
    }, [id]);
    


    const handleSearch = (e) => {
    
        let text = e.target.value;
        
        setIsMemberLoading(true);
        setSearchValue(text);
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        // Only update searchField after user stops typing for 500ms
        let timeout = setTimeout(() => {
            setSearchField(text)	
        }, 500);

        setSearchTimeout(timeout);
    };
    useEffect(() => {
        membersList.length > 0 && setMembersList(originalList.filter((item) => item.name.toLowerCase().includes(searchValue.toLowerCase())))
        setIsMemberLoading(false);
    }, [searchField])


    useEffect(() => {
        if (action === 'CREATE') {
            setShowForm(true)
        }
    }, [action])
    
    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return decodeURIComponent(match[2]);
        return null;
    };
    useEffect(() => {
        const cookieLocation = getCookie('location');	
        if (cookieLocation) {
            setData({
                ...data,
                location: cookieLocation,
            })
            setSelectedLocation(cookieLocation);
        }
    }, []);
    
    const initializeData = () => {

        setIsLoading(true);
        api.getEventDetail(id).then((res) => {
            setIsLoading(false);
            const dataValue = res.data;
            setData({
                id: dataValue.id,
                name: dataValue.name,
                date: dataValue.date,
                location: dataValue.location,
                participants: dataValue.participants || []
            });
        });
    }

    const getMembersFromEvent = () => {
        setIsMemberLoading(true)
        api.getMembersFromEvent(id, selectedLocation).then((res) => {
            setIsMemberLoading(false);
            const dataValue = res.data?.data?.data || [];
            setOriginalList(dataValue);
            setMembersList(dataValue);
        });
    }

    useEffect(() => {
        if (showAttendance) {
            getMembersFromEvent()   
        }
    }, [showAttendance])

    const isMobile = useIsMobile();

    const variants = {
        enter: { x: 50, opacity: 0 },
        center: { x: 0, opacity: 1 },
        exit: { x: -50, opacity: 0, position: 'absolute' } // Absolute prevents layout jumping
    };


    const handleSubmitForm = (e) => {
        if (data.name?.trim() == '') {
            toast.error("Member's Name is required.");
            return false
        }   
        const request = {
            id: data.id,
            name: data.name,
            location: data.location,
            date: data?.date,
        }
        // console.log('formData', formData)
        // return false;
        if (action === 'EDIT') {
            api.updateEvent(id, request).then(
                (res) => {
                    if (res.status) {
                        toast.success(res.message);
                        // handleClose();
                        reloadList();
                    } else {
                        toast.error(res.message);
                    }
                },
                (err) => {
                    toast.error(err.message);
                }
            );
        } else if (action === 'CREATE') {
            api.createEvent(request).then(
                (res) => {
                    if (res.status) {
                        toast.success(res.message);
                        // handleClose();
                        reloadList();
                    } else {
                        toast.error(res.message);
                    }
                },
                (err) => {
                    toast.error(err.message);
                }
            );
        }
    }


    const handleChangeStatus = (memberId, checked) => {

        const request = {is_present: checked, event_id: id, member_id: memberId};
        api.updateMembersFromEvent(request).then(
            (res) => {
                if (res.status) {
                    toast.success('Attendance has been successfully updated');
                    // getMembersFromEvent();
                    // reloadList();
                } else {
                    toast.error(res.message);
                }
            },
            (err) => {
                toast.error(err.message);
            }
        );
    }


    return (
        isVisible && (

            <div 
                className={`glass-effect-popup-overlay ${isVisible && 'show'}`}
                onClick={handleClose}
            >
                <div 
                    className={`glass-effect-popup-container ${isMobile && 'lg' } ${isVisible ? 'glassAnimateFadeIn' : 'glassAnimateFadeOut'}`}
                    style={{ display: isVisible ? 'block' : 'none', width: !isMobile ? '600px' : '100%', marginTop: -30 }}
                    onClick={e => e.stopPropagation()}
                >
                    {/* <button className="glass-effect-popup-close-icon">&times;</button> */}
                    {/* <button className="btn modal-close-icon text-black" onClick={handleClose}>
                        <svg height="16" width="16" viewBox="0 0 19.295 19.289">
                            <path d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
                        </svg>
                    </button> */}
                    
                    <div className="glass-effect-popup-content">
                        <div className="row">
                            <div className="col-12" style={{ marginBottom: '10px' }}>
                                

                               
                            <AnimatePresence mode="wait">
                                {showAttendance ? (
                                    /* --- PREVIEW VIEW --- */
                                    <motion.div
                                        key="preview"
                                        variants={variants}
                                        initial="enter"
                                        animate="center"
                                        exit="exit"
                                        transition={{ duration: 0.25, ease: "easeInOut" }}
                                        style={{ width: '100%' }}
                                    >
                                        <div
                                            className="mb-2 flex justify-content-between align-items-center"
                                            style={{
                                                marginTop: '-25px',
                                                zIndex: 20,
                                            }}
                                        >
                                            <button
                                                className="btn modal-back-icon"
                                                onClick={() => {
                                                    setShowAttendance(false)
                                                    setShowForm(false)
                                                    console.log('na back')
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    top: '-25px',
                                                    left: 0,
                                                    zIndex: 20,
                                                }}
                                            >
                                                <ChevronLeftIcon height={'16px'} width={'16px'} />
                                            </button>
                                            <button
                                                className="btn modal-close-icon"
                                                onClick={reloadList}
                                                style={{
                                                    position: 'absolute',
                                                    top: '-25px',
                                                    right: 0,
                                                    zIndex: 20,
                                                }}
                                            >
                                                <CloseIcon height={'16px'} width={'16px'} />
                                            </button>
                                        </div>

                                        <div className="text-center mb-4" style={{ marginTop: '20px' }}>
                                            <div style={{ fontSize: '20px', fontWeight: '600' }}>{data?.name}</div>
                                            <div className='text-muted' style={{ fontSize: '13px' }}>
                                                Choose member who attended the event. You can update members status by clicking the box.
                                                
                                            </div>
                                        </div>
                                            <div className="text-center">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div
                                                        className="flex mb10"
                                                        style={{
                                                            zIndex: '100',
                                                            padding: '12px 0',
                                                            background: '#fff'
                                                        }}
                                                    >
                                                        
                                                        <input
                                                            type="text"
                                                            placeholder="Search"
                                                            value={searchValue}
                                                            className={`form-control`}
                                                            onChange={(e) => {
                                                                handleSearch(e)
                                                                // setSearchValue(e.target.value)
                                                            }}
                                                            style={{
                                                                boxShadow: '#e7e5e5 0px 0px 20px 0px',
                                                                borderRadius: '32px',
                                                            }}
                                                        />
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                fontSize: '25px',
                                                                top: '15px',
                                                                right: '24px',
                                                                color: '#afafaf',
                                                            }}
                                                        >
                                                            <IoSearchOutline />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div style={{overflowY: 'auto', height: 'calc(100vh - 450px)'}}>
                                                        {
                                                            isMemberLoading ? (
                                                                [...Array(100)].map((e, i) => (
                                                                    <div
                                                                        className="flex align-items-center mb10"
                                                                        style={{
                                                                            justifyContent: 'space-between',
                                                                            // boxShadow: '#e7e5e5 0px 0px 20px 0px',
                                                                            alignItems: 'center',
                                                                            // padding: '15px',
                                                                            borderRadius: '32px',
                                                                            border: '1px solid #e0e0e0',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    >
                                                                        <Skeleton variant="rounded" width={'100%'} height={40} style={{ borderRadius: '32px' }} />
                                                                    </div> 
                                                                ))
                                                            ) : (
                                                                membersList?.map((item, index) => {
                                                                    return (
                                                                        <div
                                                                            className="flex align-items-center mb10"
                                                                            style={{
                                                                                // justifyContent: 'space-between',
                                                                                // // boxShadow: '#e7e5e5 0px 0px 20px 0px',
                                                                                // alignItems: 'center',
                                                                                // padding: '15px',
                                                                                // borderRadius: '18px',
                                                                                // border: '1px solid #e0e0e0',
                                                                                // cursor: 'pointer',
                                                                                // background: item?.attended ? '#018c01' : 'transparent',
                                                                                // color: item?.attended ? '#fff' : '#000',

                                                                                justifyContent: 'space-between',
                                                                                padding: '10px 17px',
                                                                                background: item?.attended ? 'linear-gradient(to right, #8e44ad, #3498db)' : 'transparent',
                                                                                color: item?.attended ? '#fff' : '#000',
                                                                                fontFamily: 'Arial, sans-serif',
                                                                                fontSize: '14px',
                                                                                textTransform: 'capitalize',
                                                                                borderRadius: '32px',
                                                                                border: 'none',
                                                                                // boxShadow: '0 4px 6px rgba(0, 0, 0, 0.15)',
                                                                                border: item?.attended ? '1px solid transparent' : '1px solid #e0e0e0',
                                                                                cursor: 'pointer',
                                                                                transition: 'transform 0.2s, box-shadow 0.2s',
                                                                            }}
                                                                            onClick={() => {
                                                                                handleChangeStatus(item?.id, !item?.attended)

                                                                                setMembersList(membersList.map((member) => {
                                                                                    if (member.id === item.id) {
                                                                                        return {
                                                                                            ...member,
                                                                                            attended: !member.attended
                                                                                        }
                                                                                    }
                                                                                    return member
                                                                                }))
                                                                                setOriginalList(originalList.map((member) => {
                                                                                    if (member.id === item.id) {
                                                                                        return {    
                                                                                            ...member,
                                                                                            attended: !member.attended
                                                                                        }
                                                                                    }   
                                                                                    return member
                                                                                }))
                                                                                
                                                                            }}
                                                                        >
                                                                            <div>
                                                                                {item?.name}
                                                                            </div>
                                                                            {
                                                                                item?.is_new && (
                                                                                    <div className={`badge badge-dark-gray`} style={{ width: '70px' }}>
                                                                                        New
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    )
                                                                })
                                                            )
                                                        } 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div 
                                            className="mt-4 flex justify-content-end gap-2"
                                        >
                                            <button
                                                onClick={reloadList}
                                                className="btn btn-main-primary btn-outlined-main"
                                                style={{ height: '40px' }}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </motion.div>
                                ) : showForm ? (
                                    /* --- PREVIEW VIEW --- */
                                    <motion.div
                                        key="preview"
                                        variants={variants}
                                        initial="enter"
                                        animate="center"
                                        exit="exit"
                                        transition={{ duration: 0.25, ease: "easeInOut" }}
                                        style={{ width: '100%' }}
                                    >
                                        <div
                                            className="mb-2 flex justify-content-between align-items-center"
                                            style={{
                                                marginTop: '-25px',
                                            }}
                                        >
                                            {
                                                action === 'CREATE' ? (
                                                    <div></div>
                                                ) : (
                                                    <button
                                                        className="btn modal-back-icon"
                                                        onClick={() => {
                                                            setShowAttendance(false)
                                                            setShowForm(false)
                                                        }}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '-25px',
                                                            left: 0,
                                                            zIndex: 20,
                                                        }}
                                                    >
                                                        <ChevronLeftIcon height={'16px'} width={'16px'} />
                                                    </button>
                                                )
                                            }
                                            <button
                                                className="btn modal-close-icon"
                                                onClick={handleClose}
                                                style={{
                                                    position: 'absolute',
                                                    top: '-25px',
                                                    right: 0,
                                                    zIndex: 20,
                                                }}
                                            >
                                                <CloseIcon height={'16px'} width={'16px'} />
                                            </button>
                                        </div>

                                   
                                        <div className="row">
                                            <div className="col-12 text-center fw-500" style={{ fontSize: '18px', marginBottom: '20px' }}>
                                                {
                                                    action === 'EDIT' ? 'Update Details' : action === 'CREATE' ? 'Create New Event' : ''
                                                }
                                            </div>
                                        </div>
                                        <div className="row mb10">
                                            <div className="col-12">
                                                <label>Name</label>
                                                
                                                <input
                                                    type="text"
                                                    value={data?.name}
                                                    onChange={(e) => {
                                                        setData({
                                                            ...data,
                                                            name: e.target.value
                                                        })
                                                    }}
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <label>Date</label>
                                                
                                                <input
                                                    type="date"
                                                    value={data?.date}
                                                    onChange={(e) => {
                                                        setData({
                                                            ...data,
                                                            date: e.target.value
                                                        })
                                                    }}
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>

                                        <div 
                                            className="glass-effect-popup-actions"
                                        >
                                            <button
                                                className="btn btn-cmpny-dtls-action btn-block flex"
                                                style={{
                                                    justifyContent: "center",
                                                    marginBottom: "-5px",
                                                }}
                                                onClick={() => {
                                                    handleSubmitForm()
                                                }}
                                            >
                                                {action === 'EDIT' ? 'Save' : action === 'CREATE' ? 'Create' : ''}
                                            </button>
                                            <button onClick={handleClose} className="btn btn-main-primary btn-outlined-main">Close</button>
                                        </div>
                                    </motion.div>
                                ) : (
                                    /* --- LIST VIEW --- */
                                    <motion.div
                                        key="list"
                                        variants={variants}
                                        initial="enter"
                                        animate="center"
                                        exit="exit"
                                        transition={{ duration: 0.25, ease: "easeInOut" }}
                                        style={{ width: '100%' }}
                                    >
                                    <div
                                        className="mb-2 flex justify-content-end"
                                            style={{
                                                position: 'absolute',
                                                top: -35,
                                                right: 0,
                                            }}
                                        >
                                            <button className="btn modal-close-icon" onClick={handleClose}>
                                                <CloseIcon height={'16px'} width={'16px'} />
                                            </button>
                                        </div>

                                        <div className="text-center mb-4">
                                            <div style={{ fontSize: '20px', fontWeight: '600' }}>{data?.name}</div>
                                            <div className='text-muted' style={{ fontSize: '13px' }}>
                                                Choose from the options below to view details and manage the event.
                                                
                                            </div>
                                        </div>

                                        {
                                            isLoading ? (
                                                    
                                                [...Array(2)].map((e, i) => (
                                                    <div 
                                                        className="border rounded p-3 mb-2 hover-shadow" 
                                                        style={{ transition: 'all 0.2s', border: '1px solid #eee', cursor: 'not-allowed', boxShadow: '#e7e5e5 0px 0px 20px 0px' }}
                                                    >
                                                        <div className="flex align-items-center justify-content-between">
                                                            <div className="flex align-items-center" style={{ gap: '12px' }}>
                                                                <div>
                                                                    <Skeleton variant="rounded" width={30} height={30} className="mx-auto" />
                                                                </div>
                                                                    
                                                                <div>
                                                                    <div style={{ fontWeight: '500', marginBottom: '4px' }}>
                                                                        <Skeleton variant="rounded" width={200} height={15} className="mx-auto" />
                                                                    </div>
                                                                    <div className="text-muted" style={{ fontSize: '11px' }}>
                                                                        <Skeleton variant="rounded" width={50} height={15} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style={{ transform: 'rotate(180deg)', opacity: 0.5 }}>
                                                                <ChevronLeftIcon height={'14px'} width={'14px'} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div>
                                                                
                                                    <div 
                                                        className="bg-white border rounded p-3 mb-2 cursor-pointer hover-shadow"
                                                        style={{ transition: 'all 0.2s', border: '1px solid #eee' }}
                                                        onClick={() => {
                                                            setShowForm(true)
                                                            setShowAttendance(false)
                                                            // setAttachmentUrl(item?.attachment_url);
                                                            // setAttachmentFileName(item?.filename);
                                                        }}
                                                    >
                                                        <div className="flex align-items-center justify-content-between">
                                                            <div className="flex align-items-center" style={{ gap: '12px' }}>
                                                                
                                                                <div>
                                                                    <div style={{ fontWeight: '500' }}>Update Event </div>
                                                                    <div className="text-muted" style={{ fontSize: '11px' }}>Edit event details</div>
                                                                </div>
                                                            </div>
                                                            <div style={{ transform: 'rotate(180deg)', opacity: 0.5 }}>
                                                                <ChevronLeftIcon height={'14px'} width={'14px'} />
                                                            </div>
                                                        </div>
                                                    </div> 
                                                    <div 
                                                        className="bg-white border rounded p-3 mb-2 cursor-pointer hover-shadow"
                                                        style={{ transition: 'all 0.2s', border: '1px solid #eee' }}
                                                        onClick={() => {
                                                            setShowAttendance(true)
                                                            setShowForm(false)
                                                            // setAttachmentUrl(item?.attachment_url);
                                                            // setAttachmentFileName(item?.filename);
                                                        }}
                                                    >
                                                        <div className="flex align-items-center justify-content-between">
                                                            <div className="flex align-items-center" style={{ gap: '12px' }}>
                                                                
                                                                <div>
                                                                    <div style={{ fontWeight: '500' }}>Attendance</div>
                                                                    <div className="text-muted" style={{ fontSize: '11px' }}>
                                                                        Participants: <span className={`fw-500 ${data?.participants?.length > 0 ? 'text-green-500' : 'text-gray-600'}`}>{data?.participants?.length || 0}</span>        
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style={{ transform: 'rotate(180deg)', opacity: 0.5 }}>
                                                                <ChevronLeftIcon height={'14px'} width={'14px'} />
                                                            </div>
                                                        </div>
                                                    </div> 
                                                </div>
                                            )
                                        }
                                            


                                        <div className="mt-4 flex justify-content-end">
                                            <button onClick={handleClose} className="btn btn-main-primary btn-outlined-main">Close</button>
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence> 



                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    )


};

export default EventFormModal;























